import { type DocumentVariableMetadata, documentVariable } from './document-variable'

/**
 * Metadatos del INMUEBLE (datos físicos y registrales).
 *
 * Las versiones «en letras» de los numéricos NO son variables: son la máscara `letters` aplicable
 * a cualquiera. Una variable, N presentaciones.
 */

export const PROPERTY_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'nombre_propiedad',
    label: 'Nombre de la Propiedad',
    category: 'property',
    type: 'string',
    example: 'Casa Modelo Premium'
  }),
  documentVariable({
    key: 'codigo_propiedad',
    label: 'Código de la Propiedad',
    category: 'property',
    type: 'string',
    description: 'Código único de la propiedad',
    example: 'VHCASA205'
  }),
  documentVariable({
    key: 'tipo_propiedad',
    label: 'Subtipo',
    category: 'property',
    type: 'string',
    description: 'Código del subtipo',
    example: 'VH205'
  }),
  documentVariable({
    key: 'tipo_nombre_propiedad',
    label: 'Nombre del Subtipo',
    category: 'property',
    type: 'string',
    example: 'Casa'
  }),
  documentVariable({
    key: 'unidad',
    label: 'Unidad',
    category: 'property',
    type: 'enum',
    description: 'Tipo de unidad',
    optionsFromHost: true,
    example: 'Apartamento'
  }),
  documentVariable({
    key: 'unidad_tipo',
    label: 'Unidad - Tipo',
    category: 'property',
    type: 'string',
    description: 'El "Tipo" de la unidad, tal cual (ej. A, 3). Admite máscara "en letras".',
    example: '3',
    masks: ['letters']
  }),
  documentVariable({
    key: 'unidad_tipo_letras',
    label: 'Unidad - Tipo en letras',
    category: 'property',
    type: 'string',
    description: 'Si el Tipo es número lo da en letras (3 → Tres); si es letra, igual (A)',
    example: 'Tres'
  }),
  documentVariable({
    key: 'estructura',
    label: 'Estructura',
    category: 'property',
    type: 'enum',
    optionsFromHost: true,
    example: 'Torre'
  }),
  documentVariable({
    key: 'estructura_numero',
    label: 'Estructura - Número',
    category: 'property',
    type: 'number',
    description: 'Número de la estructura',
    example: '1'
  }),
  documentVariable({
    key: 'estructura_codigo',
    label: 'Estructura - Código',
    category: 'property',
    type: 'string',
    description: 'Código corto de la estructura',
    example: 'T1'
  }),
  documentVariable({
    key: 'identificador',
    label: 'Identificador del inmueble',
    category: 'property',
    type: 'number',
    description: 'Identificador numérico',
    example: '303'
  }),
  documentVariable({
    key: 'terreno_m2',
    label: 'Terreno M2',
    category: 'property',
    type: 'number',
    example: '180'
  }),
  documentVariable({
    key: 'terreno_v2',
    label: 'Terreno V2',
    category: 'property',
    type: 'number',
    example: '210'
  }),
  documentVariable({
    key: 'construccion_m2',
    label: 'Construcción M2',
    category: 'property',
    type: 'number',
    example: '150'
  }),
  documentVariable({
    key: 'terraza_m2',
    label: 'Terraza M2',
    category: 'property',
    type: 'number',
    example: '38.32'
  }),
  documentVariable({
    key: 'parqueo_m2',
    label: 'Parqueo M2 (inmueble)',
    category: 'property',
    type: 'number',
    example: '10'
  }),
  documentVariable({
    key: 'finca',
    label: 'Finca',
    category: 'property',
    type: 'string',
    description: 'Número de finca registral',
    example: '123'
  }),
  documentVariable({
    key: 'folio',
    label: 'Folio',
    category: 'property',
    type: 'string',
    description: 'Número de folio registral',
    example: '1234'
  }),
  documentVariable({
    key: 'libro',
    label: 'Libro',
    category: 'property',
    type: 'string',
    description: 'Número de libro registral',
    example: '4321'
  }),
  documentVariable({
    key: 'monto_iusi',
    label: 'Monto IUSI',
    category: 'property',
    type: 'number',
    description: 'Impuesto Único Sobre Inmuebles',
    example: '100000'
  }),
  documentVariable({
    key: 'contador_agua',
    label: 'Contador de Agua',
    category: 'property',
    type: 'string',
    example: '12345678'
  }),
  documentVariable({
    key: 'contador_electricidad',
    label: 'Contador de Electricidad',
    category: 'property',
    type: 'string',
    example: 'T80865'
  }),
  documentVariable({
    key: 'telefono_propiedad',
    label: 'Teléfono de la Propiedad',
    category: 'property',
    type: 'string',
    example: '2222-2222'
  })
]
